import { render, staticRenderFns } from "./ShareholderSummary.vue?vue&type=template&id=2c1c120a&scoped=true"
import script from "./ShareholderSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderSummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ShareholderSummary.vue?vue&type=style&index=0&id=2c1c120a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c120a",
  null
  
)

export default component.exports